import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
const controller = rpcController("Documentacion");
import { cacheResource, bindResource, addOnInvalidateHandler, invalidateResource } from "kea-resource";
import { onCambioTarifa } from "./tarifaupdate";
import { Cliente } from "./cliente";

export const Documentacion = cacheResource({
    /**A partir de una documentación, obtiene las guias que fueron generadas debido a la misma */
    ObtenerGuias: async (servicios: models.DocumentacionServicios): Promise<models.DocumentacionGuias> =>
        await controller("ObtenerGuias", {}, servicios),

    /**
     * Agrega un conjunto de guias de una documentación. Devuelve el id de la nueva documentación
     * @param servicios Servicios de la documentación
     * @param pagoRealizado Pago realizado
     */
    AgregarDocumentacion: async (documentacion: models.NuevaDocumentacion): Promise<models.DocumentacionFactura> => await controller("AgregarDocumentacion", {}, documentacion),

    /**Determina si un envío de documentación es de zona extendida */
    EsZonaExtendida: async (servicios: models.ServiciosAdicionales | null, idSucursalDestino: number | null, idDireccionDestino: number | null): Promise<boolean> =>
        (servicios == null || idSucursalDestino == null || idDireccionDestino == null) ? false :
            await controller('EsZonaExtendida', { idSucursalDestino, idDireccionDestino }, servicios),

    /**En caso de que no se pueda mandar el servicio como FXC, devuelve el error de validación, si el FXC si es válido, devuelve null */
    ValidarFXC: async (servicios: models.ServiciosAdicionales | null, idSucursalDestino: number | null, idDireccionDestino: number | null): Promise<models.ErrorFletePorCobrar | null> =>
        (servicios == null || idSucursalDestino == null || idDireccionDestino == null) ? null :
            await controller('ValidarFXC', { idSucursalDestino, idDireccionDestino }, servicios),

    /**Obtiene un conjunto de documentaciones dado un rango de fechas de creación */
    Query: async (fechaIni: Date, fechaFin: Date): Promise<models.DocumentacionDTO[]> => await controller("Query", { fechaIni, fechaFin }),

    /**Obtiene una documentación dado su ID */
    Get: async (id: number): Promise<models.DocumentacionDTO> => await controller("Get", { id }),


    /**
     * Imprime las guias y las etiquetas de las guias
     * @param idDocumentacion 
     */
    ImprimirGuias: async (idDocumentacion: number): Promise<string> => await controller('ImprimirGuias', { idDocumentacion }),

    /**Obtiene si una dirección de un cliente tiene cobertura de EAD */
    TieneCoberturaEAD: async (idDireccionDestino: number, idSucursalDestino: number): Promise<boolean> => await controller('TieneCoberturaEAD', { idDireccionDestino, idSucursalDestino }),

    ValidarFolioPPDocu: async (tipo: models.TipoServicio, folio: string): Promise<models.ErrorFolioPPDocumentacion | null> => await controller('ValidarFolioPPDocu', { tipo, folio }),

    ObtenerServiciosAdicionalesFolioPPDocu: async (folio: string): Promise<models.ServiciosAdicionalesTarifaPP> => await controller('ObtenerServiciosAdicionalesFolioPPDocu', { folio }),

    ValidarFolioPPDocuConServicios: async (tipo: models.TipoServicio, folio: string): Promise<models.ErrorFolioPPDocumentacionConServiciosAdicionales> => await controller('ValidarFolioPPDocuConServicios', { tipo, folio }),

}, {
        ObtenerGuias: true,
        Query: true,
        Get: true,
    }, {
        AgregarDocumentacion: true
    });

//Invalidamos la documentación cuando cambie la tarifa
onCambioTarifa.subscribe(() => invalidateResource(Documentacion));
addOnInvalidateHandler(Documentacion, () => invalidateResource(Cliente));



// WEBPACK FOOTER //
// ./app/resources/items/documentacion.tsx